/**
 * Navigation translations
 * Includes: Bottom navigation, top navigation
 */
export default {
  home: 'Home',
  message: 'Message',
  messages: 'Messages',
  strangerMessages: 'Stranger Messages',
  follow: 'Follow',
  profile: 'Profile',
  video: 'Video Call',
  chat: 'Chat',
  vip: 'VIP',
  userDetail: 'User Detail',
  diamond: 'Diamond',
}
